import { TextButton, Textarea } from "oui";
import { useEffect, useState } from "react";
import { ISurveyQuestionOption } from "../../../infra/api/SurveyApi";

export interface ISurveyOptionInput extends ISurveyQuestionOption {
    selected: boolean;
}

export interface SurveyOption {
    option: ISurveyOptionInput,
    onClick: (option: ISurveyQuestionOption, selected: boolean) => boolean,
    onChangeText: (option: ISurveyQuestionOption, text: string) => void,
}

const OptionButton = ({
    option,
    onClick,
    onChangeText
}: SurveyOption) => {
    const [text, setText] = useState("");

    const onClickOption = () => {
        const newSelected = !option.selected;
        option.selected = newSelected;
        if (onClick) {
            onClick(option, newSelected);
        }
    }

    const onChangeDirectText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setText(e.target.value);
        if (onChangeText) {
            onChangeText(option, e.target.value);
        }
    }

    return (
        <div>
            <TextButton
                text={option.optionText}
                iconLeft={{
                    name: 'CheckCircle',
                    state: `${option.selected ? 'focused' : 'enabled'}`
                }}
                size="md"
                iconColor="primary"
                onClickButton={() => onClickOption()}
                state="enabled"
            />
            {option.inputType === "02" && option.selected === true &&
                <Textarea placeholder="내용을 입력해주세요." maxCount={50} onChange={onChangeDirectText} text={text} state={"enabled"}></Textarea>
            }
        </div>
    );
};

export default OptionButton;